import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import DashboardRoutes from './routes'
import { BackTop } from 'antd'
import { actions } from '../../redux/modules/dashboard/dashboardActions'
import { actions as userActions } from '../../redux/modules/userActions'
import DataHeader from '../../components/dashboard/DataHeader'
import ColapsePanel from '../../components/dashboard/ColapsePanel'
import history from '../../history'
import _ from 'lodash'
import UserSwitch from './UserSwitch'

const propTypes = {}

class Dashboard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      detailShowing: true,
      selectedUser: null,
      currentPage: 'follow-ups'
    }

    this.props.getLeadsPerMonth()
    this.props.getLeadsStatusCountPerMonth()
    this.props.getUsers()
  }

  handleClickMenu = e => {
    this.setState({
      currentPage: e.key
    })
    history.push(`/dashboard/${e.key}`)
  }

  toggleDetails = () => {
    this.setState({
      detailShowing: !this.state.detailShowing
    })
  }

  selectUser = userId => {
    this.setState({
      selectedUser: userId
    })
  }

  render() {
    const leadsOfMonth = _.get(this.props, 'dashboardActions.leadsOfMonth.data')
    const loadingLeadsPerMonth = _.get(this.props, 'dashboardActions.loadingLeadsPerMonth')
    const leadsStatusCount = _.get(this.props, 'dashboardActions.leadsStatusCount.data')
    const loadingLeadsStatusCount = _.get(this.props, 'dashboardActions.loadingLeadsStatusCount')
    const users = _.get(this.props, 'userActions.users.data')
    return (
      <div>
        <BackTop />
        <DataHeader
          handleClickMenu={this.handleClickMenu}
          currentKey={this.state.currentKey}
          currentPage={this.state.currentPage}
          screenWidth={this.state.screenWidth}
        />
        <div className="dataPanel">
          <div className="wrapPanel">
            <ColapsePanel
              toggleDetails={this.toggleDetails}
              detailShowing={this.state.detailShowing}
              leadsOfMonth={leadsOfMonth}
              loadingLeadsPerMonth={loadingLeadsPerMonth}
              leadsStatusCount={leadsStatusCount}
              loadingLeadsStatusCount={loadingLeadsStatusCount}
            />
            {this.props.authentication.user.isAdmin && (
              <UserSwitch users={users} selectUser={this.selectUser} />
            )}
            <DashboardRoutes selectedUser={this.state.selectedUser} />
            &copy; G-Tech Elevator Associates LLC
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ dashboardActions, authentication, userActions }, ownProps) => ({
  dashboardActions,
  authentication,
  userActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, userActions), dispatch)
})

Dashboard.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard))



// WEBPACK FOOTER //
// ./src/containers/dashboard/Dashboard.js